import { render } from "./마스코트.vue?vue&type=template&id=36250353"
import script from "./마스코트.vue?vue&type=script&lang=js"
export * from "./마스코트.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__